<template>
  <div class="wrapper">
    <div class="title">Bookings per region</div>
    <div id="bookingsPerRegion"></div>
  </div>
</template>

<script>
const am4core = require("@amcharts/amcharts4/core");
const am4charts = require("@amcharts/amcharts4/charts");
const dayjs = require("dayjs");
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
const customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
import am4themes_material from "@amcharts/amcharts4/themes/material";
export default {
  components: {},
  props: {
    stats: {
      type: Object,
      required: true,
    },
    customers: {
      type: Array,
      required: true,
    },
    regions: {
      type: Array,
      required: true,
    },
    mode: {
      type: String,
      required: false,
    },
    selectedDate: {
      type: Date,
      required: true,
    },
  },
  data: function () {
    return {
      chartData: [],
      chart: {},
      currentTimezone: dayjs.tz.guess(),
      formattedSelectedDate: dayjs(this.selectedDate),
    };
  },
  methods: {
    Today: async function () {
      am4core.useTheme(am4themes_material);
      this.chart = am4core.create("bookingsPerRegion", am4charts.XYChart);
      let chart = this.chart;
      chart.legend = new am4charts.Legend();
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "time";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.labels.template.rotation = 300;
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      let today = this.stats[this.formattedSelectedDate.format("DD-MM-YYYY")];
      let todaysDate = this.formattedSelectedDate.format("DD-MM-YYYY");
      const dataObj = {};
      for (const [time, timeData] of Object.entries(today)) {
        let date = dayjs(`${todaysDate} ${time}`, "DD-MM-YYYY HH:mm").utc(true);
        if (!dataObj[time]) {
          dataObj[time] = {
            time: dayjs.tz(date, this.currentTimezone).format("HH:mm"),
          };
        }

        for (const [customerId, customerData] of Object.entries(timeData)) {
          let customerObj = this.customers.find((customerSearch) => {
            return customerSearch.id == customerId;
          });
          if (customerObj === undefined || customerObj.type == "dev" || customerObj.type == "demo") {
            continue;
          }
          let regionName = customerObj.billing_region;
          for (const [outcome, amount] of Object.entries(customerData)) {
            if (outcome.toLowerCase() == "booked") {
              if (!dataObj[time][regionName]) dataObj[time][regionName] = 0;
              dataObj[time][regionName] += amount;
            }
          }
        }
      }
      for (const [key, value] of Object.entries(dataObj)) {
        this.chartData.push(value);
      }
      chart.data = this.chartData;

      let colors = ["#47d061", "#1E2EDE", "#DF2935", "#F3A916", "#08A4BD", "#9E2B25", "#7B5E7B", "#2A4849", "#4C1E4F", "#2A6186", "#C0A9B0"];

      for (const regionData of this.regions) {
        let series = new am4charts.LineSeries();
        series.dataFields.valueY = `${regionData}`;
        series.dataFields.categoryX = "time";
        series.stroke = am4core.color(colors[colors.length - 1]);
        series.strokeWidth = 4;
        series.fill = am4core.color(colors[colors.length - 1]);
        series.tooltipText = `${regionData} Bookings: {${regionData}}`;
        series.tooltip.background.fill = am4core.color("#47d061");
        series.name = `${regionData}`;
        chart.series.push(series);
        colors.splice(-1, 1);
      }
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.maxTooltipDistance = 20;
    },
  },
  mounted() {
    this.Today();
  },
  beforeDestroy() {
    this.chart.dispose();
  },
};
</script>

<style scoped>
#chart {
  display: block;
}

.wrapper {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 20fr;
  height: 370px;
}

.title {
  font-size: 1.2em;
  display: flex;
  justify-content: center;
}
</style>
